import {
  MaintenanceTaskInterface,
  MaintenanceTaskType,
} from "module/maintenanceTask/types";

export const isMaintenanceTaskProcessStepCheckedResultAvailable = (
  maintenanceTask: MaintenanceTaskInterface
): boolean => maintenanceTask.type === MaintenanceTaskType.preventive;
